import { FormGroup, HTMLSelect, Tab, Tabs } from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from 'react-bootstrap-table2-editor';
import { CalcVarStore } from "../../stores/vars/CalcVarStore";
import { Pager } from "../utils/Pager";
import { IconButton } from "@mui/material";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { observable } from "mobx";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import LoadingModal from "../loading/LoadingModal";

interface Props {
}

interface State {
}

@observer
export class CalcVarsPage extends React.Component<Props, State> {

  obs = observable({
    page: 1 as number,
    tab: "calcs" as string,
    collection: "calc_vars" as string
  })

  constructor(props: any) {
    super(props);

    AppStore.setTitle("Variáveis de Cálculos");

  }

  async componentDidMount() {

    this.obs.page = 1
    this.obs.collection = "calc_vars"
    this.obs.tab = "calcs"

    await CalcVarStore.load(this.obs.page, this.obs.tab, this.obs.collection);

  }

  redirectCalc = (calc_id: string) => {

    if (this.obs.tab == "calcs") {

      window.open(`/calc/edit/${calc_id}`, "_blank")

    } else if (this.obs.tab == "calcs_conta") {

      window.open(`/calc/edit/${calc_id}/contas`, "_blank")

    } else if (this.obs.tab == "calcs_rs") {

      window.open(`/calc-rs/edit/${calc_id}`, "_blank")

    } else if (this.obs.tab == "calcs_conta_rs") {

      window.open(`/calc-rs/edit/${calc_id}/contas`, "_blank")

    } else { }

  };

  async handlePageChange(page: number) {

    this.obs.page = page

    await CalcVarStore.load(page, this.obs.tab, this.obs.collection);

  }

  async handleDelete(id: string) {

    let res = await CalcVarStore.delete(id, this.obs.collection)

    if (res) {

      await CalcVarStore.load(this.obs.page, this.obs.tab, this.obs.collection)

    }

  }

  formatDetalhes = (row: any) => {

    if (!row.calc) {

      return (<>
        {"Nenhum cálculo encontrado!"}{" "}
        <IconButton onClick={(e) => this.handleDelete(row._id)}>
          <img src="/images/bin.png" width="18px" />
        </IconButton>
      </>);

    }

    return (<>
      {row.calc.nome}{" "}
      <IconButton onClick={(e) => this.redirectCalc(row.calc_id)}>
        <img src="/images/view.png" width="18px" />
      </IconButton>
    </>);

  }

  async handleChangeTipo(tableId: string) {

    this.obs.tab = tableId
    this.obs.page = 1

    if (tableId === "calcs" || tableId === "calcs_conta") {

      this.obs.collection = "calc_vars"

    }

    await CalcVarStore.load(1, tableId, this.obs.collection)

  }

  async handleChangeCollection(collection: string) {

    this.obs.collection = collection
    this.obs.page = 1

    await CalcVarStore.load(1, this.obs.tab, collection)

  }

  formatDescricao = (row: any) => {

    return (<>
      {row.descricao}{" "}<IconButton><img src="/images/edit.png" width="18px" /></IconButton>
    </>);

  }

  render() {

    const columns = [
      { dataField: '_id', text: '#', isKey: true, hidden: true, },
      { dataField: 'nome', text: 'Nome', editable: false, headerStyle: { width: '200px' } },
      { dataField: 'expr', text: 'Fórmula', editable: false, formatter: (cell, row) => `${row.nome} = ${row.expr}` },
      { dataField: 'descricao', text: 'Descrição', editable: true, formatter: (cell, row) => this.formatDescricao(row) },
      { dataField: 'calc', text: 'Cálculo', editable: false, formatter: (cell, row) => this.formatDetalhes(row) },
    ]

    const beforeSaveCell = async (oldValue, newValue, row, column, done) => {

      if (oldValue === newValue) return

      let res = await CalcVarStore.put(row._id, newValue, this.obs.collection)

      if (res) {

        await CalcVarStore.load(this.obs.page, this.obs.tab, this.obs.collection)

      }

    }

    return (
      <div>

        <Tabs
          id="tabs"
          className={"tabsCalculos calcs"}
          onChange={(tableId) => this.handleChangeTipo(String(tableId))}
          selectedTabId={this.obs.tab}
        >
          <Tab id="calcs" title="Cálculos" />
          <Tab id="calcs_conta" title="Cálculos Exclusivos" />
          <Tab id="calcs_rs" title="Cálculos - RS" />
          <Tab id="calcs_conta_rs" title="Cálculos Exclusivos - RS" />
          <Tab id="outros" title="Outros" />
        </Tabs>

        {["calcs_rs", "calcs_conta_rs", "outros"].includes(this.obs.tab) &&

          <FormGroup label="Modelo" style={{ width: 200 }}>
            <HTMLSelect
              onChange={(e) => this.handleChangeCollection(e.target.value)}
              value={this.obs.collection}
            >
              <option value="calc_vars">NORMAL</option>
              <option value="calc_vars_fcp">FCP</option>
            </HTMLSelect>
          </FormGroup>

        }

        <BootstrapTable
          keyField="_id"
          data={CalcVarStore.obs.vars_calc}
          columns={columns}
          cellEdit={cellEditFactory({ mode: 'click', blurToSave: true, beforeSaveCell })}
          wrapperClasses="TableDefault tabela-excesso"
        />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.page}
            totalCount={CalcVarStore.obs.length}
            pageSize={20}
            onPageChange={page => this.handlePageChange(page)}
          />
        </div>

        <LoadingModal open={CalcVarStore.obs.loading} onClose={() => CalcVarStore.obs.loading = false} title={"Carregando itens"} />

      </div>
    );
  }
}

export default CalcVarsPage;
